var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#465e88",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 24h-19C1.121 24 0 22.878 0 21.5v-19C0 1.122 1.121 0 2.5 0h19C22.879 0 24 1.122 24 2.5v19c0 1.378-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v19c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5h-19z",
    transform: "translate(-660.000000, -52.000000) translate(599.000000, 36.000000) translate(16.000000, 16.000000) translate(45.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16h-2C5.121 16 4 14.878 4 13.5v-3C4 9.122 5.121 8 6.5 8h2c.276 0 .5.224.5.5s-.224.5-.5.5h-2C5.673 9 5 9.673 5 10.5v3c0 .827.673 1.5 1.5 1.5h2c.276 0 .5.224.5.5s-.224.5-.5.5zM20.5 16h-2c-1.379 0-2.5-1.122-2.5-2.5v-3C16 9.122 17.121 8 18.5 8h2c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.827 0-1.5.673-1.5 1.5v3c0 .827.673 1.5 1.5 1.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z",
    transform: "translate(-660.000000, -52.000000) translate(599.000000, 36.000000) translate(16.000000, 16.000000) translate(45.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5h-4c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4c.276 0 .5.224.5.5s-.224.5-.5.5zM12.75 16H10.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.25c.689 0 1.25-.561 1.25-1.25s-.561-1.25-1.25-1.25h-.5c-1.24 0-2.25-1.009-2.25-2.25S11.01 8 12.25 8h2.25c.276 0 .5.224.5.5s-.224.5-.5.5h-2.25c-.689 0-1.25.561-1.25 1.25s.561 1.25 1.25 1.25h.5c1.24 0 2.25 1.009 2.25 2.25S13.99 16 12.75 16z",
    transform: "translate(-660.000000, -52.000000) translate(599.000000, 36.000000) translate(16.000000, 16.000000) translate(45.000000, 0.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscape);
export default __webpack_public_path__ + "static/media/escape.cfe74c0d.svg";
export { ForwardRef as ReactComponent };